import { combineReducers } from 'redux-immutable';

import lista from './lista';
import filtroLivre from './filtro_livre';
import filtroEstruturado from './filtro_estruturado';
import detalhes from './detalhes';

export default combineReducers({ lista, filtroLivre, filtroEstruturado, detalhes });
